module.exports = __webpack_public_path__ + "static/media/bg-cover-2.71d55855.png";